import React from 'react';

import {
    BlogWrapper,
    BlogTitle,
    LastUpdated,
    ContentText,
} from '../../../components/PrivacyPolicy/styles';
import { makeStaticProps, getStaticPaths } from '../../../lib/next-i18next/getStatic';
import { Header } from '../../../components/blog/header';
import { Footer } from '../../../components/blog/footerBlog';
import { FaceLiftGlobalStyle } from '../../../styles/theme';
import WhatsAppButton from '../../../components/WhatsAppButton';

function PrivacyPolicy() {
    return (
        <>
            <FaceLiftGlobalStyle />
            <Header showHero={false} />
            <WhatsAppButton />

            <BlogWrapper>
                <div className="container-blog">
                    <BlogTitle>Política de Privacidade</BlogTitle>
                    <LastUpdated>Última atualização: 23 de março de 2026</LastUpdated>

                    <ContentText>
                        <p>
                            A <strong>Verzel Soluções em Sistemas Ltda</strong> (&ldquo;Verzel&rdquo;, &ldquo;nós&rdquo;, &ldquo;nosso&rdquo; ou &ldquo;nossa&rdquo;), inscrita no CNPJ
                            sob o nº 11.845.885/0001-46, com sede na Rua Aníbal Benévolo, 94 - 2° Andar, Santana, São
                            Paulo/SP, CEP 02016-040, tem o compromisso de proteger a privacidade e a segurança dos
                            dados pessoais de seus clientes, parceiros e usuários (&ldquo;você&rdquo;, &ldquo;seu&rdquo; ou &ldquo;sua&rdquo;) que acessam
                            nosso site www.verzel.com.br e utilizam nossos serviços.
                        </p>
                        <p>
                            Esta Política de Privacidade foi elaborada em conformidade com a Lei Geral de Proteção de
                            Dados Pessoais (LGPD - Lei nº 13.709/2018) e tem como objetivo fornecer informações claras
                            e precisas sobre como coletamos, utilizamos, armazenamos, compartilhamos e protegemos
                            seus dados pessoais.
                        </p>
                        <p>
                            Recomendamos a leitura cuidadosa deste documento. Ao utilizar nosso site e serviços, você
                            reconhece que leu e compreendeu as práticas descritas nesta Política.
                        </p>

                        <h2>1. Quais dados pessoais coletamos?</h2>
                        <p>
                            A Verzel coleta apenas os dados pessoais estritamente necessários para fornecer nossos
                            serviços de tecnologia, atender às suas solicitações e melhorar sua experiência em nosso site.
                            Os dados podem ser coletados das seguintes formas:
                        </p>

                        <h3>1.1. Dados fornecidos diretamente por você</h3>
                        <p>
                            Quando você preenche o formulário de contato em nosso site, solicita informações sobre nossos
                            serviços ou se candidata a uma vaga de emprego, podemos coletar os seguintes dados:
                        </p>
                        <ul>
                            <li><strong>Dados de identificação e contato:</strong> Nome completo, endereço de e-mail corporativo,
                                número de telefone (com código de país) e nome da empresa em que atua.</li>
                            <li><strong>Dados profissionais:</strong> Informações sobre seu projeto ou desafio tecnológico, cargo e
                                outras informações que você decida compartilhar conosco no campo de mensagem.</li>
                            <li><strong>Dados de acesso:</strong> Credenciais de login (caso possua acesso à área restrita do nosso site).</li>
                        </ul>

                        <h3>1.2. Dados coletados automaticamente</h3>
                        <p>
                            Quando você navega em nosso site, podemos coletar informações de forma automática por
                            meio de cookies e tecnologias semelhantes, tais como:
                        </p>
                        <ul>
                            <li><strong>Dados de navegação e dispositivo:</strong> Endereço IP, tipo de navegador, sistema
                                operacional, páginas visitadas, tempo de permanência no site, links clicados e dados de
                                geolocalização aproximada.</li>
                        </ul>

                        <h2>2. Para quais finalidades utilizamos seus dados?</h2>
                        <p>
                            A Verzel realiza o tratamento de seus dados pessoais para propósitos legítimos, específicos e
                            explícitos, sempre amparados por uma base legal prevista na LGPD. Utilizamos seus dados
                            para as seguintes finalidades:
                        </p>

                        <table>
                            <thead>
                                <tr>
                                    <th>Finalidade do Tratamento</th>
                                    <th>Base Legal (LGPD)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Retornar o contato via WhatsApp, telefone ou e-mail para agendar conversas com nossos especialistas e discutir seu projeto.</td>
                                    <td>Consentimento ou Execução de Contrato / Procedimentos Preliminares</td>
                                </tr>
                                <tr>
                                    <td>Prestar os serviços de tecnologia contratados (desenvolvimento de sistemas, RPA, integração de IA, etc.).</td>
                                    <td>Execução de Contrato</td>
                                </tr>
                                <tr>
                                    <td>Fornecer acesso à área de login para clientes e parceiros.</td>
                                    <td>Execução de Contrato</td>
                                </tr>
                                <tr>
                                    <td>Enviar comunicações sobre nossos serviços, novidades, eventos e artigos do nosso blog, desde que você tenha autorizado.</td>
                                    <td>Consentimento ou Legítimo Interesse</td>
                                </tr>
                                <tr>
                                    <td>Melhorar o desempenho, a segurança e a usabilidade do nosso site, analisando métricas de acesso.</td>
                                    <td>Legítimo Interesse</td>
                                </tr>
                                <tr>
                                    <td>Cumprir obrigações legais, regulatórias ou ordens judiciais.</td>
                                    <td>Cumprimento de Obrigação Legal ou Regulatória</td>
                                </tr>
                            </tbody>
                        </table>

                        <h2>3. Com quem compartilhamos seus dados?</h2>
                        <p>
                            A Verzel preza pela confidencialidade dos seus dados e não os comercializa. O
                            compartilhamento de informações ocorre apenas quando necessário para a prestação dos
                            serviços ou cumprimento de obrigações legais, envolvendo:
                        </p>
                        <ul>
                            <li><strong>Fornecedores e Parceiros de Tecnologia:</strong> Empresas que fornecem infraestrutura de
                                hospedagem em nuvem, sistemas de CRM, ferramentas de análise de dados e
                                plataformas de comunicação (como o WhatsApp), que atuam como operadores de
                                dados sob nossas diretrizes e contratos rigorosos de confidencialidade.</li>
                            <li><strong>Empresas do Grupo ou Filiais:</strong> Podemos compartilhar dados com nossos escritórios
                                em Lisboa (Portugal) e Berlim (Alemanha) para fins de gestão interna e suporte a
                                projetos globais.</li>
                            <li><strong>Autoridades Públicas:</strong> Quando exigido por lei, regulamentação ou ordem judicial.</li>
                        </ul>

                        <h3>Transferência Internacional de Dados</h3>
                        <p>
                            Como possuímos escritórios na Europa e utilizamos serviços de computação em nuvem que
                            podem ter servidores localizados fora do Brasil, seus dados podem ser transferidos
                            internacionalmente. A Verzel garante que tais transferências ocorram apenas para países que
                            proporcionem grau de proteção de dados adequado ou mediante a adoção de garantias
                            contratuais, conforme exigido pela LGPD.
                        </p>

                        <h2>4. Como protegemos seus dados?</h2>
                        <p>
                            Adotamos medidas técnicas, administrativas e organizacionais adequadas para proteger seus
                            dados pessoais contra acessos não autorizados, perda, destruição, alteração ou qualquer forma
                            de tratamento inadequado ou ilícito. Nossas práticas de segurança incluem:
                        </p>
                        <ul>
                            <li>Controle estrito de acesso aos dados, restrito apenas a colaboradores autorizados e
                                necessários para a execução das atividades.</li>
                            <li>Uso de criptografia para proteger dados em trânsito e em repouso.</li>
                            <li>Monitoramento contínuo de nossos sistemas para detectar e prevenir vulnerabilidades
                                e ataques.</li>
                            <li>Treinamento periódico de nossa equipe sobre proteção de dados e segurança da
                                informação.</li>
                        </ul>

                        <h2>5. Por quanto tempo armazenamos seus dados?</h2>
                        <p>
                            Reteremos seus dados pessoais apenas pelo tempo necessário para cumprir as finalidades para
                            as quais foram coletados, conforme descrito nesta Política, ou para o cumprimento de
                            obrigações legais, regulatórias ou para o exercício regular de direitos em processos judiciais,
                            administrativos ou arbitrais.
                        </p>
                        <p>
                            Quando os dados não forem mais necessários, eles serão excluídos de forma segura ou
                            anonimizados, impossibilitando a sua identificação.
                        </p>

                        <h2>6. Quais são os seus direitos como titular de dados?</h2>
                        <p>
                            A LGPD garante a você, titular dos dados, uma série de direitos em relação às suas informações
                            pessoais. A qualquer momento, você pode solicitar à Verzel:
                        </p>
                        <ul>
                            <li><strong>Confirmação e Acesso:</strong> Confirmação da existência de tratamento e acesso aos dados
                                que possuímos sobre você.</li>
                            <li><strong>Correção:</strong> Correção de dados incompletos, inexatos ou desatualizados.</li>
                            <li><strong>Anonimização, Bloqueio ou Eliminação:</strong> De dados desnecessários, excessivos ou
                                tratados em desconformidade com a lei.</li>
                            <li><strong>Portabilidade:</strong> Transferência dos seus dados a outro fornecedor de serviço ou produto,
                                mediante requisição expressa.</li>
                            <li><strong>Eliminação:</strong> Exclusão dos dados tratados com o seu consentimento, exceto nas
                                hipóteses de guarda legal.</li>
                            <li><strong>Informação sobre Compartilhamento:</strong> Informações sobre as entidades públicas e
                                privadas com as quais compartilhamos seus dados.</li>
                            <li><strong>Revogação do Consentimento:</strong> Revogação do consentimento fornecido
                                anteriormente, a qualquer momento, de forma gratuita e facilitada.</li>
                        </ul>
                        <p>
                            Para exercer qualquer um desses direitos, entre em contato conosco através dos canais
                            disponibilizados na seção &ldquo;Contato&rdquo;.
                        </p>

                        <h2>7. Uso de Cookies</h2>
                        <p>
                            Nosso site utiliza cookies para melhorar a sua experiência de navegação, entender como você
                            interage com nosso conteúdo e personalizar anúncios.
                        </p>
                        <ul>
                            <li><strong>Cookies Estritamente Necessários:</strong> Essenciais para o funcionamento do site e não
                                podem ser desativados em nossos sistemas.</li>
                            <li><strong>Cookies de Desempenho e Análise:</strong> Permitem contar visitas e fontes de tráfego para
                                medir e melhorar o desempenho do nosso site.</li>
                            <li><strong>Cookies de Funcionalidade:</strong> Permitem que o site forneça funcionalidade e
                                personalização aprimoradas.</li>
                        </ul>
                        <p>
                            Você pode configurar seu navegador para recusar todos ou alguns cookies, ou para alertá-lo
                            quando os sites definem ou acessam cookies. No entanto, se você desativar ou recusar cookies,
                            observe que algumas partes deste site podem se tornar inacessíveis ou não funcionar
                            corretamente.
                        </p>

                        <h2>8. Alterações nesta Política de Privacidade</h2>
                        <p>
                            A Verzel reserva-se o direito de atualizar ou modificar esta Política de Privacidade a qualquer
                            momento, visando refletir melhorias em nossos processos ou adequações legais.
                            Recomendamos que você revise esta página periodicamente para se manter informado sobre
                            como protegemos suas informações. A data da última atualização estará sempre em destaque
                            no início do documento.
                        </p>

                        <h2>9. Contato do Encarregado de Dados (DPO)</h2>
                        <p>
                            Se você tiver dúvidas, comentários, solicitações ou preocupações sobre esta Política de
                            Privacidade ou sobre o tratamento de seus dados pessoais, entre em contato com nosso
                            Encarregado pelo Tratamento de Dados Pessoais (DPO) através dos seguintes canais:
                        </p>
                        <div className="contact-info">
                            <p><strong>E-mail:</strong> <a href="mailto:ti@verzel.com.br">ti@verzel.com.br</a></p>
                            <p><strong>Endereço para correspondência:</strong> Rua Aníbal Benévolo, 94 - 2° Andar, Santana - São Paulo/SP - CEP 02016-040</p>
                            <p><strong>Telefones:</strong> (11) 3562-7277 ou 0800 558 0066</p>
                        </div>
                    </ContentText>
                </div>
            </BlogWrapper>

            <Footer />
        </>
    )
};

const getStaticProps = makeStaticProps()
export { getStaticPaths, getStaticProps }

export default PrivacyPolicy;
